import { render } from "./CompleteV2.vue?vue&type=template&id=1b3fef60&scoped=true"
import script from "./CompleteV2.vue?vue&type=script&lang=ts"
export * from "./CompleteV2.vue?vue&type=script&lang=ts"

import "./CompleteV2.vue?vue&type=style&index=0&id=1b3fef60&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1b3fef60"

export default script